import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { WarningPopUp, Image } from "hesus-ui-kit";
import { handleApiError } from "@utils/errorHandler";
import { ButtonContainer } from "./PriceAction.styled";
import editIcon from "@icons/ic-edit-blue.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import copyIcon from "@icons/ic-copy.svg";
import activateIcon from "@icons/ic-activate.svg";
import AddEditCenterProductPrice from "../../../AddEditCenterProductPrice/AddEditCenterProductPrice";
import "../../PriceList.scss";

const PriceAction = (props) => {
  const {
    t,
    data,
    onRefreshData,
    updateRefeshStatus,
    transportTypes,
    companyId,
    centerId,
    centerProductId,
    countryId,
  } = props;

  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [actionType, setActionType] = useState("edit");
  const [isConfirm, setActionConfirmStatus] = useState(false);
  const [
    isEditCenterProductPricePopupVisible,
    setIsEditCenterProductPricePopupVisible,
  ] = useState(false);
  const [confirmationBoxTitle, setConfirmationBoxTitle] = useState(
    "CENTER_PRODUCT_PRICE_CONFIRMATION_BOX_DELETE"
  );
  const [confirmationBoxContent, setConfirmationBoxContent] = useState(
    "CENTER_PRODUCT_PRICE_CONFIRMATION_BOX_DELETE_CONTENT"
  );
  const handleCenterProductPriceAction = (status) => {
    if (status === 1) {
      setConfirmationBoxTitle("CENTER_PRODUCT_PRICE_CONFIRMATION_BOX_ENABLE");
      setConfirmationBoxContent(
        "CENTER_PRODUCT_PRICE_CONFIRMATION_BOX_ENABLE_CONTENT"
      );
    } else {
      setConfirmationBoxTitle("CENTER_PRODUCT_PRICE_CONFIRMATION_BOX_DELETE");
      setConfirmationBoxContent(
        "CENTER_PRODUCT_PRICE_CONFIRMATION_BOX_DELETE_CONTENT"
      );
    }
    setConfirmVisibility(true);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  useEffect(() => {
    if (isConfirm) {
      const formStatus = data.isActive === 1 ? "0" : 1;
      axios
        .post(
          `/companies/${data.companyId}/centres/${data.centreId}/products/${data.centreProductId}/prices/${data.id}/updateStatus`,
          formStatus
        )
        .then(() => {
          onRefreshData(true);
        })
        .catch((error) => {
          onRefreshData(true);
          handleApiError(error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  const editPrice = (action) => {
    setIsEditCenterProductPricePopupVisible(true);
    setActionType(action);
  };

  const closePriceEditPopup = () => {
    setIsEditCenterProductPricePopupVisible(false);
  };

  return (
    <ButtonContainer>
      {data.centreProductStatus === 1 && (
        <div>
          <Image
            src={editIcon}
            title={t("PRICE_ACTION_TOOLTIP_EDIT")}
            onClick={() => editPrice("edit")}
            alt={t("PRICE_ACTION_TOOLTIP_EDIT")}
            className="center-product-price-list__image-icon"
          />
          {data?.isActive == 1 && (
            <Image
              src={deleteIcon}
              onClick={() => handleCenterProductPriceAction(0)}
              alt={t("PRICE_ACTION_TOOLTIP_DISABLE ")}
              title={t("PRICE_ACTION_TOOLTIP_DISABLE ")}
              className="center-product-price-list__image-icon"
            />
          )}
          {data?.isActive == 0 && (
            <Image
              src={activateIcon}
              onClick={() => handleCenterProductPriceAction(1)}
              alt={t("PRICE_ACTION_TOOLTIP_ACTIVATE")}
              title={t("PRICE_ACTION_TOOLTIP_ACTIVATE")}
              className="center-product-price-list__image-icon"
            />
          )}
          <Image
            src={copyIcon}
            title={t("PRICE_ACTION_TOOLTIP_COPY")}
            onClick={() => editPrice("copy")}
            alt={t("PRICE_ACTION_TOOLTIP_COPY")}
            className="center-product-price-list__image-icon"
          />
        </div>
      )}

      {isConfirmVisible && (
        <WarningPopUp
          title={t(confirmationBoxTitle)}
          message={t(confirmationBoxContent)}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
      {isEditCenterProductPricePopupVisible && (
        <AddEditCenterProductPrice
          id={data.id}
          title={t("EDIT_PRICE")}
          onClose={closePriceEditPopup}
          actionType={actionType}
          updateRefeshStatus={updateRefeshStatus}
          transportTypes={transportTypes}
          companyId={companyId}
          centerId={centerId}
          centerProductId={centerProductId}
          countryId={countryId}
        />
      )}
    </ButtonContainer>
  );
};

PriceAction.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    canEdit: PropTypes.number,
  }).isRequired,
  t: PropTypes.func.isRequired,
  onRefreshData: PropTypes.func.isRequired,
};
export default withTranslation()(PriceAction);
